module.exports = __webpack_public_path__ + "img/kkb_multimedia.262cb85b.png";